import React, { ErrorInfo, ReactNode } from 'react';
import { sendMonitorNotif } from '../services/analyticsService';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo)
    console.error('Uncaught error:', error, errorInfo);
    sendMonitorNotif({ type: 'boundaries', userId: 'N/A', source: 'class' });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="text-center p-6">
          <h1 className="text-2xl font-semibold text-gray-600 mb-4">Something went wrong :(</h1>
          <div className="flex justify-center gap-4">
            <button
              onClick={() => window.location.reload()}
              className="bg-deehiy text-white px-4 py-2 rounded hover:opacity-90 transition"
            >
              Reload the page
            </button>
            <a
              href="/"
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300 transition"
            >
              Go to home page
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
